import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ModalCreateFolderComponent } from 'app/components/modal-create-folder/modal-create-folder.component';
import { Folder } from 'app/interfaces/folder.interface';
import { FolderService } from 'app/services/folder.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-modal-add-to-folder',
  templateUrl: './modal-add-to-folder.component.html',
  styleUrls: ['./modal-add-to-folder.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatCheckboxModule, MatIconModule, FormsModule, TranslocoPipe],
})
export class ModalAddToFolderComponent implements OnInit {
  dialogRef = inject(MatDialogRef<ModalAddToFolderComponent>);
  data = inject<{ queryId: string; currentFolderIds: string[] }>(MAT_DIALOG_DATA);
  private folderService = inject(FolderService);
  private dialog = inject(MatDialog);
  private destroyRef = inject(DestroyRef);

  folders: Folder[] = [];
  selectedIds = new Set<string>();

  ngOnInit(): void {
    this.folderService.folders$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((folders) => {
      this.folders = folders;
    });
    this.folderService.refreshFolders();
    this.selectedIds = new Set(this.data.currentFolderIds);
  }

  isSelected(folder: Folder): boolean {
    return this.selectedIds.has(folder.id);
  }

  toggle(folder: Folder): void {
    if (this.selectedIds.has(folder.id)) {
      this.selectedIds.delete(folder.id);
    } else {
      this.selectedIds.add(folder.id);
    }
  }

  createFolder(): void {
    this.dialog
      .open(ModalCreateFolderComponent, { data: {}, width: '400px' })
      .afterClosed()
      .pipe(
        tap((name: string | null) => {
          if (!name) {
            return;
          }
          this.folderService
            .createFolder(name)
            .pipe(
              tap((folder) => {
                this.folderService.refreshFolders();
                this.selectedIds.add(folder.id);
              }),
              takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
        })
      )
      .subscribe();
  }

  confirm(): void {
    this.dialogRef.close(Array.from(this.selectedIds));
  }
}
